import React, { useState } from 'react';
import './pay-token-redemption-footer.scss';
import { FileSelectionButton } from 'components';
import { IconBtn } from '@ru-digital-assets/ui-component';
import { ArrowRight, EditIcon } from 'assets/icons';
import { TokenRedemptionType } from 'constants/redemption';
import {
  RedemptionDateModal,
  RedemptionDateAndReasonModal,
} from './components';

interface IPayTokenRedemptionFooter {
  onSubmit: (file: File, date: Date, reason?: string) => void;
  redemptionType: TokenRedemptionType;
}

export default function PayTokenRedemptionFooter({
  onSubmit,
  redemptionType,
}: IPayTokenRedemptionFooter) {
  const [file, setFile] = useState<File>();
  const [redemptionDateModalOpen, setRedemptionDateModalOpen] = useState(false);
  const [
    redemptionDateAndReasonModalOpen,
    setRedemptionDateAndReasonModalOpen,
  ] = useState(false);

  return (
    <div className="pay-token-redemption-footer">
      <div className="pay-token-redemption-footer__controls">
        <FileSelectionButton
          label={
            redemptionType === 'execution'
              ? 'Приложите документ, подтверждающий оплату'
              : 'Приложите документ, подтверждающий прекращение обязательств'
          }
          onFileChange={(file) => setFile(file)}
        />
        <div className="pay-token-redemption-footer__submit-button">
          <IconBtn
            lg
            title={
              redemptionType === 'execution'
                ? 'Прикрепить документ и отправить Обладателю'
                : 'Прикрепить'
            }
            icon={
              redemptionType === 'execution' ? (
                <ArrowRight color="#fff" />
              ) : (
                <EditIcon color="#fff" />
              )
            }
            disabled={!file}
            onClick={
              redemptionType === 'execution'
                ? () => setRedemptionDateModalOpen(true)
                : () => setRedemptionDateAndReasonModalOpen(true)
            }
          />
        </div>
      </div>
      <RedemptionDateModal
        open={redemptionDateModalOpen}
        onClose={() => setRedemptionDateModalOpen(false)}
        onSubmit={(date) => {
          setRedemptionDateModalOpen(false);
          onSubmit(file!, date);
        }}
      />
      <RedemptionDateAndReasonModal
        open={redemptionDateAndReasonModalOpen}
        onClose={() => setRedemptionDateAndReasonModalOpen(false)}
        onSubmit={(date, reason) => {
          setRedemptionDateAndReasonModalOpen(false);
          onSubmit(file!, date, reason);
        }}
      />
    </div>
  );
}
